import React, { useEffect, useState } from "react";
import ErasureMethodForm from "./ErasureMethodForm";
import { Paper, withStyles, Grid, Dialog } from "@material-ui/core";
import { BackButton, hasPermission } from '../../sc-utilities';
import { connect } from "react-redux";
import * as Yup from "yup";
import * as actions from "./store/erasureMethodActions";
import History from "../../../History";
import { CancelToken } from 'axios';
import AppLogoLoading from '../../sc-logo';

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        paddingRight: theme.spacing(6),
        margin: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        }
    },
    submit: {
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "hidden",
        alignItems: "center"
    },
    logo: {
        width: "250px",
        margin: "10px"
    }
});

const ErasureMethodCreate = props => {
    const { classes, activeCustomerID, translations, permissions, onCreateErasureMethod, onListSupportedClientTypes } = props;
    const [createData, setCreateData] = useState({ supportedClientTypes: [], loadingData: true });

    useEffect(() => {
        const requestToken = CancelToken.source();
        const fetchData = async () => {
            let supportedClientTypes = await onListSupportedClientTypes({ ActiveCustomerID: activeCustomerID }, { CancelToken: requestToken.token });
            setCreateData({ supportedClientTypes: supportedClientTypes, loadingData: false });
        }
        fetchData();
        return () => {
            requestToken.cancel('Operation canceled by the user.');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const extractSupportedClientTypes = selectedSupportedClientTypes => {
        return selectedSupportedClientTypes.map(supportedClientType => supportedClientType.value);
    };

    const handleSubmit = async data => {
        let formData = { ...data };
        formData['SupportedClientTypeIDs'] = extractSupportedClientTypes(data.SupportedClientTypes);
        delete formData.SupportedClientTypes;
        let result = await onCreateErasureMethod({ ...formData, ActiveCustomerID: activeCustomerID });
        if (result) {
            History.goBack();
        }
    };

    let initialValues = {
        Key: "",
        Visible: false,
        LongName: "",
        ShortName: "",
        SupportedClientTypes: [],
        DedicatedFor: "all",
        Description: "",
    };

    let formSettings = {
        Validation: {
            Key: Yup.string().required("Required"),
            LongName: Yup.string().required("Required"),
            ShortName: Yup.string().required("Required"),
            DedicatedFor: Yup.string().required("Required"),
        },
        FormTitle: translations["create_securaze_standard"] || "Create securaze standard",
        ButtonSubmit: hasPermission(permissions, "erasure_method_create") ? {
            Title: translations["save"] || "SAVE",
            Color: 'primary'
        } : null
    };

    return (
        <Paper className={classes.root}>
            <Grid container spacing={10}>
                <Grid item xs={12}>
                    {BackButton(translations)}
                    <Dialog disableBackdropClick={true} disableEscapeKeyDown={false} open={createData.loadingData}
                        PaperProps={{
                            classes: {
                                root: classes.submit
                            }
                        }}
                    >
                        <AppLogoLoading />
                    </Dialog>
                    {!createData.loadingData ?
                        <ErasureMethodForm
                            classes={classes}
                            formSettings={formSettings}
                            initialValues={initialValues}
                            handleSubmit={handleSubmit}
                            translations={translations}
                            supportedClientTypes={createData.supportedClientTypes}
                        /> : null}
                </Grid>
            </Grid>
        </Paper>
    );
};

const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        permissions: state?.core?.login?.permissions || [],
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onCreateErasureMethod: erasureMethod => dispatch(actions.createErasureMethod(erasureMethod)),
        onListSupportedClientTypes: (data, option) => dispatch(actions.listSupportedClientTypes(data, option)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(ErasureMethodCreate));